function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 32.5C19.7651 32.5 17.6092 31.5772 16.0102 29.9142C14.4093 28.2493 13.5 25.979 13.5 23.6C13.5 21.7118 14.1991 19.9457 15.3279 18.1898C16.4033 16.5169 17.7973 14.957 19.2228 13.3617C19.3101 13.264 19.3976 13.1662 19.4851 13.0681C19.4851 13.068 19.4852 13.068 19.4853 13.0679L20.8812 11.5048C21.4776 10.8369 22.5224 10.837 23.1188 11.5048L24.5145 13.0677C24.6031 13.1669 24.6915 13.2659 24.7799 13.3649C26.2045 14.9597 27.5973 16.5189 28.6721 18.1908C29.801 19.9468 30.5 21.7125 30.5 23.6C30.5 25.979 29.5907 28.2493 27.9898 29.9142C26.3908 31.5772 24.2349 32.5 22 32.5Z",
  stroke: "currentcolor",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 25C19 25 19.5 26.5 21 27",
  stroke: "currentcolor",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var SvgAddWatermark = function SvgAddWatermark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddWatermark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-watermark.a0cd3256.svg";
export { ForwardRef as ReactComponent };